import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import Config from "./BaseConfig.js";
import { ALLOWED_URL_CONFIG } from "../internal/internalConstants.js";
var URLConfig = /*#__PURE__*/function (_Config) {
  /**
   * @param {IURLConfig} userURLConfig
   */
  function URLConfig(userURLConfig) {
    var _this;
    _classCallCheck(this, URLConfig);
    _this = _callSuper(this, URLConfig);
    var urlConfig = _this.filterOutNonSupportedKeys(userURLConfig, ALLOWED_URL_CONFIG);
    Object.assign(_this, {
      secure: true
    }, urlConfig);
    return _this;
  }
  _inherits(URLConfig, _Config);
  return _createClass(URLConfig, [{
    key: "extend",
    value: function extend(userURLConfig) {
      var urlConfig = this.filterOutNonSupportedKeys(userURLConfig, ALLOWED_URL_CONFIG);
      return new URLConfig(Object.assign({}, this, urlConfig));
    }
    /**
     * @param {string} value Sets the cname
     */
  }, {
    key: "setCname",
    value: function setCname(value) {
      this.cname = value;
      return this;
    }
    /**
     * @param {string} value Sets the secureDistribution
     */
  }, {
    key: "setSecureDistribution",
    value: function setSecureDistribution(value) {
      this.secureDistribution = value;
      return this;
    }
    /**
     * @param {boolean} value Sets whether to use a private CDN (Removes cloudName from URL)
     */
  }, {
    key: "setPrivateCdn",
    value: function setPrivateCdn(value) {
      this.privateCdn = value;
      return this;
    }
    /**
     * @param value Sets whether or not to sign the URL
     */
  }, {
    key: "setSignUrl",
    value: function setSignUrl(value) {
      this.signUrl = value;
      return this;
    }
    /**
     * @param value Sets whether or not to use a long signature
     */
  }, {
    key: "setLongUrlSignature",
    value: function setLongUrlSignature(value) {
      this.longUrlSignature = value;
      return this;
    }
    /**
     * @param value Sets whether or not to shorten the URL
     */
  }, {
    key: "setShorten",
    value: function setShorten(value) {
      this.shorten = value;
      return this;
    }
    /**
     * @param value Sets whether or not to use a root path
     */
  }, {
    key: "setUseRootPath",
    value: function setUseRootPath(value) {
      this.useRootPath = value;
      return this;
    }
    /**
     * @param value Sets whether or not to deliver the asset through https
     */
  }, {
    key: "setSecure",
    value: function setSecure(value) {
      this.secure = value;
      return this;
    }
    /**
     * @param value Sets whether to force a version in the URL
     */
  }, {
    key: "setForceVersion",
    value: function setForceVersion(value) {
      this.forceVersion = value;
      return this;
    }
    /**
     * @param params Sets additional params
     */
  }, {
    key: "setQueryParams",
    value: function setQueryParams(params) {
      this.queryParams = params;
      return this;
    }
  }]);
}(Config);
export default URLConfig;